// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-bPG8","image":"styles_image__kfhbB","cards":"styles_cards__X+Hmf","card":"styles_card__vUTjP"};